import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Action, Store } from '@ngrx/store';

import {
    PrivaDialogButton,
    PrivaDialogComponent,
    PrivaDialogFooterButtonArea,
    PrivaDialogTypeString,
} from '@priva/components/dialog-simple';
import { PrivaLocalizationModule } from '@priva/localization';

import { ScannedCodeType } from 'app/features/scan-flow/models';
import { addScannedCode } from 'app/features/scan-flow/state/scanned-codes/scanned-codes.actions';
import { scanCodeActionDescriptions } from 'app/features/scan-flow/state/scanned-codes/utils';
import { closeDialog } from 'app/state/app-state/app-state.actions';
import { ScanQrComponent } from 'src/app/features/scan-flow/components/scan-qr/scan-qr.component';

@Component({
    selector: 'app-scan-qr-dialog',
    templateUrl: './scan-qr-dialog.component.html',
    imports: [ScanQrComponent, PrivaDialogComponent, PrivaLocalizationModule],
})
export class ScanQrDialogComponent implements OnInit, OnDestroy {
    private store = inject(Store);

    buttons: PrivaDialogButton[] = [
        {
            id: 'cancel-btn',
            text: 'GENERAL.ACTION.CANCEL',
            area: PrivaDialogFooterButtonArea.End,
            importance: 'Secondary',
        },
    ];
    title: string | undefined;
    dialogType: PrivaDialogTypeString = 'fullscreen';
    onScanFinishedAction: Action | undefined;
    scannedCodeToken: string | undefined;
    allowedCodeTypes: ScannedCodeType[] = [];

    closeDialog() {
        this.store.dispatch(closeDialog());
    }

    buttonClick(button: PrivaDialogButton) {
        if (button.id === 'cancel-btn') this.closeDialog();
    }

    onCodeScanned(scannedCode: string) {
        this.closeDialog();

        if (this.scannedCodeToken) {
            this.store.dispatch(addScannedCode({ token: this.scannedCodeToken, code: scannedCode }));
        }
    }

    ngOnInit(): void {
        this.title =
            this.allowedCodeTypes.length === 1
                ? scanCodeActionDescriptions[this.allowedCodeTypes[0]]
                : 'SCAN.ACTION.TITLE.SCAN_A_CODE';
    }

    ngOnDestroy(): void {
        if (this.onScanFinishedAction) this.store.dispatch(this.onScanFinishedAction);
    }
}
